<template>
  <div class="tw:animate-pulse tw:pb-10 tw:py-4 tw:min-h-screen-minus-footer tw:max-w-4xl tw:mx-auto">
    <div class="tw:rounded-lg tw:bg-gray-300 tw:h-[150px]" />
    <div class="tw:rounded-lg tw:bg-gray-300 tw:h-[650px] tw:mt-20" />
  </div>
</template>
